export enum WalletAppleField {
    Undefined = 0,
    LogoText = 1,
    Header = 2,
    Primary = 3,
    Secondary = 4,
    Auxiliary = 5,
    Back = 6,
    BackgroundColor = 7,
    LabelColor = 8,
    ForegroundColor = 9,
    BarcodeValue = 10,
    LogoImage = 11,
    IconImage = 12,
    ThumbnailImage = 13,
    StripImage = 14
}
